module.exports = __webpack_public_path__ + "static/media/Info.20bfb9a8.svg";